// Tiny picker for vendor/CCH master records, used inside InputForms.
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export function VendorPicker({ vendors, value, onPick, category, testId }) {
  const filtered = (vendors || []).filter((v) => !category || v.category === category || v.category === "other");
  return (
    <Select value={value || ""} onValueChange={(id) => {
      const picked = filtered.find((v) => v.id === id);
      if (picked) onPick(picked);
    }}>
      <SelectTrigger data-testid={testId} className="h-10 bg-white border-border">
        <SelectValue placeholder={filtered.length ? "Pick vendor from Setup" : "No vendors yet — add in Setup"} />
      </SelectTrigger>
      <SelectContent>
        {filtered.length === 0 && (
          <div className="px-3 py-2 text-xs text-ink-700">No {category} vendors. Add in Setup.</div>
        )}
        {filtered.map((v) => (
          <SelectItem key={v.id} value={v.id} data-testid={`${testId}-option-${v.id}`}>
            <span className="font-medium">{v.name}</span>
            {v.village && <span className="ml-2 text-xs text-ink-700">· {v.village}</span>}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}

export function CchPicker({ cchs, value, onPick, testId }) {
  return (
    <Select value={value || ""} onValueChange={(id) => {
      const picked = (cchs || []).find((c) => c.id === id);
      if (picked) onPick(picked);
    }}>
      <SelectTrigger data-testid={testId} className="h-9 bg-white border-border min-w-[200px]">
        <SelectValue placeholder={cchs?.length ? "Pick CCH from Setup" : "No CCHs yet — add in Setup"} />
      </SelectTrigger>
      <SelectContent>
        {(!cchs || cchs.length === 0) && (
          <div className="px-3 py-2 text-xs text-ink-700">No CCHs. Add in Setup.</div>
        )}
        {(cchs || []).map((c) => (
          <SelectItem key={c.id} value={c.id} data-testid={`${testId}-option-${c.id}`}>
            <span className="font-medium">{c.name}</span>
            {c.village && <span className="ml-2 text-xs text-ink-700">· {c.village}</span>}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
